<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Utilisateurs",
          icon: "bi bi-person-fill",
          route: "users-index",
        },
        {
          label: "Nouvel utilisateur",
          icon: "bi bi-person-plus-fill",
          route: "users-create",
        },
        {
          label: "Rôles",
          icon: "bi bi-shield-lock-fill",
          route: "users-roles-index",
        },
        {
          label: "Authentifications",
          icon: "bi bi-key-fill",
          route: "authentications-index",
        },
        {
          label: "IPs autorisées",
          icon: "bi bi-router-fill",
          route: "allowed-ips-index",
        },
      ],
    };
  },
};
</script>
